import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';

import { createMetaItem } from '@jane/bloom/resources/meta/createMetaVariables';

import styles from './seoHeading.module.css';

interface SeoHeadingProps {
  customSEOPage?: Nullish<CustomSEOPage>;
  defaultTitle?: Nullish<string>;
  metaVariables: Record<string, string>;
}

export function SeoHeading({
  customSEOPage,
  defaultTitle,
  metaVariables,
}: SeoHeadingProps) {
  if (!metaVariables['storeName']) return null;

  const title = createMetaItem(
    customSEOPage?.title ?? defaultTitle,
    metaVariables
  );

  return <h1 className={styles['screenReaderOnly']}>{title}</h1>;
}
